export interface ContactModel {
  key: string;
  value: string;
}

export function getEmptyContact(key='vk'): ContactModel {
  return {key, value: ''};
}
